<template>
  <v-col class="yield mx-3 pt-0">
    <bread-crumbs />

    <report-list
      v-if="showDashboard"
      :assigned-networks="assignedNetworksForCards"
    />

    <v-row
      v-else
      class="yield-report-content"
    >
      <v-col class="yield-report">
        <data-table
          ref="table"
          :actions="actions"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
/**
 * @deprecated Use AdxAndOb.vue instead.
 *
 * This component used the legacy Vuex mixin + programmatic store pattern.
 * It has been replaced by src/programmatic/views/AdxAndOb.vue which uses
 * component-level data management, FilterPanel, and ToolsToolbar per the
 * patterns established in Pacing.vue and Discrepancy.vue.
 *
 * This file is kept for reference only and will be removed in a future release.
 */
import { createNamespacedHelpers } from 'vuex'

import mixin from '../components/mixin'

const { mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'Yield',
  components: {
    BreadCrumbs: () => import('@/layout/components/BreadCrumbs'),
    DataTable: () => import('@/tools/components/table/DataTable'),
    ReportList: () => import('@/dashboard/components/ReportList'),
  },
  mixins: [mixin],
  data() {
    return {
      actions: [],
    }
  },
  computed: {
    ...mapToolsState({
      items: (state) => state.items,
      searchResults: (state) => state.searchResults,
      selectedSearch: (state) => state.selectedSearch,
    }),
    showDashboard() {
      return this.selectedSearch?.dataType === 'custom'
    },

    // Get available networks for dashboard
    availableNetworks() {
      const allReportsOrPromise = this.searchResults?.endpoints?.['yield-partner']?.items?.list
      // Handle Promise - return empty array if still pending
      const allReports = (allReportsOrPromise instanceof Promise) ? [] : (allReportsOrPromise || [])
      return allReports.filter((report) => report.dataType !== 'custom')
    },

    // Format networks for card display with proper search option properties
    assignedNetworksForCards() {
      if (!this.showDashboard) {
        return []
      }

      return this.availableNetworks.map((network) => ({
        text: network.text,

        billingCode: network.billingCode,
        networkCode: network.networkCode,

        publisherName: network.publisherName,
        publisherId: network.publisherId,
        teamId: network.teamId,
        teamCode: network.teamCode || network.teamId,

        // Search option properties for navigation
        isSearchOption: true,
        route: 'yield-partner',
        reportKey: 'yield-partner',
        reportId: network.reportId || network.billingCode,
        subId: String(network.subId || network.teamId),
        reportName: 'yield-partner',
        reportPath: 'yield-partner',
      }))
    },
  },
  async created() {
    // Self-managed view: load own data
    await this.$store.dispatch('tools/setView', 'yield-partner')
  },
}
</script>

<style lang="scss" scoped>
@import "~src/styles/variables";

.yield {
  display: flex;
  align-items: stretch;
  flex-direction: column;

  .loader {
    padding: 64px;
    align-self: center;
  }
}

.yield-report-content {
  position: relative;
}

::v-deep.filter-link {
  margin-top: 8px;
}

::v-deep.filter-content {
  margin-top: 16px;
}

::v-deep.filter-label {
  padding-top: 20px;
}

</style>
